import React, { useState } from "react";
import { Button, message } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import {
  readCampaign,
  createCampaign,
} from "../../redux/actions/campaignsAction";

export default function CopyCampaign({ campaignId, fetchRecords }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleCopy = async () => {
    setLoading(true);
    try {
      // First, fetch the full campaign details
      const campaignData = await dispatch(readCampaign({}, campaignId));

      // Prepare the copied campaign data
      const copiedData = {
        subject: `${campaignData.subject} (Copy)`,
        message: campaignData.message,
        tags: campaignData.tags || [],
        status: {
          type: "warning",
          description: "Draft",
        },
      };

      // Create the new campaign
      await dispatch(createCampaign(copiedData));

      message.success("Campaign copied successfully!");
      fetchRecords();
    } catch (error) {
      console.error("Error copying campaign:", error);
      message.error("Failed to copy campaign. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      type="text"
      icon={<CopyOutlined />}
      onClick={handleCopy}
      loading={loading}
      title="Copy Campaign"
    />
  );
}
